import { Box, Flex, Image, Text } from "@chakra-ui/react";

const Message = ({ notification }) => {
  return (
    <Box 
      border="1px solid" 
      borderColor="gray.200" 
      borderRadius="md" 
      p={4} 
      bg="white"
      boxShadow="sm"
    >
      <Flex align="center" mb={2}>
        {/* Image (optional) */}
        {notification.image && (
          <Image 
            src={notification.image} 
            boxSize="50px" 
            borderRadius="full" 
            mr={3} 
            alt="Notification"
          />
        )}
        <Text fontWeight="bold" fontSize="lg">
          {notification.title}
        </Text>
      </Flex>
      <Text color="gray.600">{notification.body}</Text>
    </Box>
  );
};

export default Message;
